import styled, { css } from 'styled-components'

import { Button } from '@/components/ui/button'
import { Icon } from '@/components/ui/icon'

export const HiddenInput = styled.input`
  display: none;
`

export const CaretIcon = styled(Icon)<{ $isOpen: boolean }>(
  ({ theme, $isOpen }) => css`
    transform: ${$isOpen ? 'rotate(0deg)' : 'rotate(180deg)'};
    transition: transform ${theme.transition.duration.sm} ease;
  `,
)

export const CopyLinkButton = styled(Button)`
  width: 14rem;
`

export const DownloadButton = styled(Button)`
  width: 15rem;
`
